import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  IconButton,
  lighten,
  Tooltip,
  Toolbar,
  Typography,
  InputBase,
  Zoom,
  Grow,
  Grid,
  TextField,
  Select,
  Menu,
  Paper,
  Button,
} from "@material-ui/core";
import {
  CloudDownload,
  CloudUpload,
  ExpandMore,
  KeyboardArrowDown,
  List,
  Search,
  Flip,
  VisibilityOff,
} from "@material-ui/icons";
import { makeStyles, withStyles } from "@material-ui/styles";
import clsx from "clsx";
import { ArrowDown, ChevronRight } from "react-feather";
import ExportExcel from "./ExportarExcel/Excel";
import { ModalGeneral } from "components";
import { Autocomplete } from "@material-ui/lab";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  textField: {
    backgroundColor: theme.palette.background.paperPrimary, // Usando el color del tema
    color: theme.palette.text.primary, // Usando el color de texto
    "& .MuiInputBase-input": {
      color: theme.palette.text.primary, // Color del texto dentro del input
    },
    "& .MuiFormLabel-root": {
      color: theme.palette.text.primary, // Color de la etiqueta
    },
  },
  helperText: {
    color: theme.palette.alert.main, // Color para el helperText
  },
  paper: {
    backgroundColor: theme.palette.background.paperPrimary, // Usando el color del tema
    color: theme.palette.text.primary, // Usando el color de texto
  },
  highlight: {},
  title: {
    flex: "1 1 100%",
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    color: "white",
    backgroundColor: theme.palette.info.main,
    "&:hover": {
      backgroundColor: theme.palette.info.light,
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "0",
    "&:focus": {
      width: "20ch",
    },
  },
  activo: {
    width: "20ch",
  },
  hiddenC: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    color: "white",
    backgroundColor: "#6ad5ff",
    "&:hover": {
      backgroundColor: "#3a7a93",
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  hidden: {
    padding: theme.spacing(0, 1),
  },
}));
const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const ButtonBusqueda = ({ onChange, value }) => {
  const classes = useStyles();
  const classesTablero = useStylesTablero();
  return (
    <div className={classes.search}>
      <div className={classes.searchIcon}>
        <Search />
      </div>
      <InputBase
        placeholder="Buscar"
        classes={{
          root: classes.inputRoot,
          input: clsx(classes.inputInput, value != "" ? classes.activo : null),
        }}
        value={value}
        onChange={onChange}
        inputProps={{ "aria-label": "search" }}
      />
    </div>
  );
};

const TopBarTable = (props) => {
  const classes = useStyles();
  let classesTablero = useStylesTablero();
  if (!props?.usarEstilosTablero) classesTablero = {};
  const {
    data,
    seleccionados,
    columnsExtra,
    onChange,
    busquedaValue,
    accionesTabla,
    toolExtra,
    filterGeneralDisabled,
    columns,
    optionsSelect,
    defaultV,
    change,
    errors,
    watch,
    save,
    newArray,
  } = props;
  const { register, handleSubmit } = useForm();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Toolbar
      className={clsx(
        classes.root,
        classes.highlight,
        classesTablero.tablaHeader
      )}
    >
      {optionsSelect && (
        <React.Fragment>
          <Paper className={classes?.background}>
            <Autocomplete
              size="small"
              options={optionsSelect}
              getOptionLabel={(option) => option.nestatus}
              // defaultValue={optionsSelect[0]}
              defaultValue={defaultV}
              onChange={change}
              value={watch("estatus")}
              style={{ width: 300 }}
              inputRef={register({
                required: {
                  value: true,
                  message: "ESTATUS ES REQUERIDO",
                },
                minLength: {
                  value: 1,
                  message: "MÍNIMO 1 CARÁCTERES",
                },
              })}
              renderInput={(params) => (
                <TextField
                  label="ESTATUS"
                  variant="outlined"
                  {...params}
                  error={Boolean(errors.estatus)}
                  helperText={errors.estatus}
                  className={classes.textField}
                />
              )}
            ></Autocomplete>
          </Paper>
        </React.Fragment>
      )}
      <div className={classes.title}>
        {accionesTabla
          .filter(
            (accion, index) =>
              !accion.disabled &&
              ((seleccionados > 0 && accion.dataSelected) ||
                (seleccionados == 0 && !accion.dataSelected))
          )
          .map((accion, index) => (
            <Tooltip key={"opcionTabla" + index} title={accion.label}>
              <IconButton
                edge="end"
                size="small"
                color="primary"
                className={accion.color}
                onClick={accion.click(data)}
              >
                {accion.icon}
              </IconButton>
            </Tooltip>
          ))}
        {toolExtra}
      </div>
      <div className={classes.hidden}>
        <Tooltip key={"opcionTabla00"} title={"Mostrar / Ocultar columnas"}>
          {/* <div > */}
          <Button
            variant="contained"
            className={classes.hiddenC}
            color="primary"
            size="small"
            onClick={handleClick}
          >
            <VisibilityOff />
          </Button>
          {/* <IconButton edge="end" size="small" aria-controls="customized-menu" aria-haspopup="true" color="inherit" onClick={handleClick}><VisibilityOff /></IconButton>
          </div> */}
        </Tooltip>
        <StyledMenu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {columns.map((column) => (
            <div key={column.name} style={{ padding: 5 }}>
              <label>
                <input
                  type="checkbox"
                  checked={newArray.includes(column.name)}
                  name={column.name}
                  onClick={save}
                />{" "}
                {column.label}
              </label>
            </div>
          ))}
          {/* <div className={classes.search}>
      <div className={classes.searchIcon}>
        <Search />
      </div>
      <InputBase
        placeholder="Buscar"
        classes={{
          root: classes.inputRoot,
          input: clsx(classes.inputInput, value != "" ? classes.activo : null),
        }}
        value={value}
        onChange={onChange}
        inputProps={{ "aria-label": "search" }}
      />
    </div> */}
        </StyledMenu>
      </div>
      {!filterGeneralDisabled && (
        <React.Fragment>
          <ExportExcel
            data={data}
            columns={columns}
            fileName="archivo"
            tipoReporte="1"
            exportar={1}
          />
          <ButtonBusqueda onChange={onChange} value={busquedaValue} />
        </React.Fragment>
      )}
    </Toolbar>
  );
};

export default TopBarTable;
